







import WidgetFrame from "@/components/WidgetFrame.vue"
import FusionChart from "@/components/charts/FusionChart.vue"
import {ChartDataTemplate, FCConfTpl} from "@/components/widgets/WidgetFather"
import {defineComponent, reactive, watch} from "@vue/composition-api"
import {fusionDataFetcher, setupConfigWatcher, setupParamWatcher} from "@/components/widgets/WidgetMother"
import {deepMerge} from "@/utils"

export default defineComponent({
  props: {
    config: Object,
    dataFetcher: Function,
    chartDataConfig: Object,
    chartDSTemplate: Object,
    configChangeCallback: Function,
    chartClickCallback: Function,
    dataplotClickCallback: Function,
    downloadUrl: String,
    errorMessage: String,
  },
  components: {
    FusionChart, WidgetFrame,
  },
  setup(props) {
    const p = props as any
    if (!p.dataFetcher) {
      console.error("prop dataFetcher is required.")
      return
    }
    const config = reactive(deepMerge({}, props.config) || {})
    watch(() => props.config, (c) => {
      deepMerge(config, c)
    }, {deep: true})
    const fetchData = fusionDataFetcher(p.dataFetcher)
    const chartConfig = reactive(p.chartConfig || FCConfTpl())
    const chartDataConfig = reactive(p.chartDataConfig || ChartDataTemplate())
    const chartDS = reactive(p.chartDSTemplate || {data: {}})
    setupParamWatcher(fetchData, chartDS, chartDataConfig, config)
    setupConfigWatcher(config, chartConfig, chartDataConfig, p.configChangeCallback)
    return {chartConfig, chartDS}
  },
})

